export const EXTENSIONS_WHITELIST = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/pdf",
];

export const FILETYPE_TO_EXTENSION_MAP = {
  "image/jpg": "jpg",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "application/pdf": "pdf",
};

export enum localStorageNames {
  IfSingleChanged = "ifSingleChanged",
  IfMultiChanged = "ifMultiChanged",
  SingleImageNumber = "SingleImageNumber",
  MultiImageNumber = "MultiImageNumber",
  SingleImageIfpdf = "SingleImageIfpdf",
  MultiImageIfpdf = "MultiImageIfpdf",
}

export enum imageTypes {
  front = "frontImage",
  back = "backImage",
  multi = "multi",
}
/* LPPLWEBMOB-454 */
